/**
 * Copyright © 2025 Delicious AI, LLC
 *
 * @author Wade Wilkey <wade.wilkey@deliciousai.com>
 */

import { gql } from '@apollo/client'

import { DISPLAY_SNAPSHOT_WITH_IMAGE_BOXES_FRAGMENT } from '@/graphql'

export const GET_DISPLAY_SNAPSHOT = gql`
  query GetDisplaySnapshot($id: ID!) {
    displaySnapshot(id: $id) {
      ...DisplaySnapshotWithImageBoxes
    }
  }
  ${DISPLAY_SNAPSHOT_WITH_IMAGE_BOXES_FRAGMENT}
`
